<!-- 管理端-绩效管理 -->
<template>
  <div class="project_index_main">
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>项目列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="project_header_box" style="display:flex;align-items:center;justify-content:space-between">
      <div>
        <h2>我的项目</h2>
        <p>选择项目进入绩效管理</p>
      </div>
      <div>
        <el-upload
          :action="importUrl"
          :show-file-list="false"
          :before-upload="beforeImportUpload"
          :on-success="handleImportSuccess"
          :on-error="handleImportError"
          accept=".xls,.xlsx"
          style="display:inline-block;margin-right:10px"
        >
          <el-button type="warning" size="small" icon="el-icon-upload2">批量导入指标</el-button>
        </el-upload>
        <el-button type="info" size="small" icon="el-icon-download" @click="downloadTemplate" style="margin-right:10px">下载导入模板</el-button>
        <el-button type="success" size="small" icon="el-icon-plus" @click="openClassDialog" style="margin-right:10px">分类管理</el-button>
        <!-- 督导导出：先拆分（合同/绩效），再合并（综合打包） -->
        <el-button type="primary" size="small" icon="el-icon-download" @click="exportContract" style="margin-right:10px">导出合同</el-button>
        <el-button type="primary" size="small" icon="el-icon-download" @click="exportPerformance" style="margin-right:10px">导出绩效资料</el-button>
        <el-button type="danger" size="small" icon="el-icon-download" @click="exportSupervision">导出督导材料</el-button>
        <el-button type="danger" size="small" icon="el-icon-download" @click="exportAll" style="margin-left:10px">一键导出全部资料</el-button>
      </div>
    </div>
    <div class="export-tip" v-if="selectedProjectIds.length > 0">
      已勾选 <span style="color:#f56c6c;font-weight:700">{{ selectedProjectIds.length }}</span> 个项目
      <el-button type="text" @click="selectedProjectIds = []">清空</el-button>
    </div>

    <!-- 搜索区域 -->
    <div class="search-box">
      <div class="search-item">
        <el-input v-model="search.keyword" placeholder="关键词" size="small" clearable @clear="init" @keyup.enter.native="init"></el-input>
      </div>
      <div class="search-item">
        <el-select v-model="search.organ_id" placeholder="机构名称" size="small" clearable filterable style="width:100%">
          <el-option v-for="item in orgOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-date-picker v-model="search.time" value-format="yyyy-MM-dd" end-placeholder="结束日期"
          range-separator="至" start-placeholder="开始日期" type="daterange" size="small" style="width:100%">
        </el-date-picker>
      </div>
      <div class="search-item">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="searchReset">重置</el-button>
        <el-button type="primary" size="small" icon="el-icon-search" @click="searchFun" style="margin-left:10px">搜索</el-button>
      </div>
    </div>

    <div class="project_list_box">
      <div class="project_list" v-if="projectList.length > 0">
        <div class="project_list_item" v-for="(item, index) in projectList" :key="index">
          <div class="project_list_item_header">
            <div class="project_list_item_name">{{ item.project_name }}</div>
            <!-- 勾选该项目参与导出 -->
            <el-checkbox v-model="selectedProjectIds" :label="item.id" class="project_list_item_check">导出</el-checkbox>
          </div>
          <div class="project_list_item_content">
            <div class="project_list_item_info">
              <div class="project_list_item_menu">
                <p>指标总数</p>
                <h2 style="color: #3381c3">{{ item.rule_count || 0 }}</h2>
              </div>
              <div class="project_list_item_menu">
                <p>完成率</p>
                <h2 class="yellow">{{ item.overall_percent || 0 }}%</h2>
              </div>
            </div>
          </div>
          <div class="project_list_item_handle">
            <el-button class="project_list_item_detail" size="small" @click="goDetail(item)">查看详情</el-button>
          </div>
        </div>
      </div>
      <div class="project_empty_box" v-else><p>暂无项目数据</p></div>
      <div class="project_page_box" v-if="search.total > search.limit">
        <el-pagination background layout="prev, pager, next"
          :total="search.total" :page-size="search.limit" :current-page.sync="search.page"
          @current-change="init"></el-pagination>
      </div>
    </div>

    <!-- 异步导出进度弹窗 -->
    <export-progress-dialog ref="exportProgress"></export-progress-dialog>

    <!-- 分类管理弹窗 -->
    <el-dialog title="分类管理" :visible.sync="classDialogShow" width="550px">
      <el-table :data="classList" border>
        <el-table-column label="序号" width="60"><template slot-scope="scope">{{ scope.$index + 1 }}</template></el-table-column>
        <el-table-column label="分类名称" prop="name"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="editClassItem(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #f56c6c" @click="deleteClassItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:15px;text-align:right">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addClassItem">添加分类</el-button>
      </div>
      <el-dialog :title="classFormTitle" :visible.sync="classFormShow" width="400px" append-to-body>
        <el-form :model="classForm" label-position="top">
          <el-form-item label="分类名称" required><el-input v-model="classForm.name" placeholder="请输入分类名称"></el-input></el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="classFormShow = false">取 消</el-button>
          <el-button type="primary" @click="handleSaveClass">保 存</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { adminGetProjectList, adminGetRuleClassList, adminSaveRuleClass, adminDeleteRuleClass, adminExportContractZip, adminExportPerformanceZip, adminExportSupervisionZip } from "@/api/adminModule";
import { getOrganPassList } from "@/api/admin";
import ExportProgressDialog from "@/components/ExportProgressDialog.vue";
import { baseURL } from "@/config";

export default {
  data() {
    return {
      importUrl: baseURL + '/admin/NewModule/importRule',
      orgOptions: [],
      search: { keyword: '', organ_id: '', time: [], page: 1, limit: 6, total: 0 },
      projectList: [],
      // 勾选参与导出的项目ID
      selectedProjectIds: [],
      classDialogShow: false, classList: [],
      classFormShow: false, classFormTitle: '', classForm: { id: 0, name: '' },
    };
  },
  components: { ExportProgressDialog },
  created() {
    this.$emit("setActive", { active: 9 });
    this.searchInit();
    this.init();
  },
  methods: {
    async searchInit() {
      const res = await getOrganPassList();
      if (res && res.code === 200) this.orgOptions = (res.data || []).map(v => ({ value: v.id, label: v.organ_name }));
    },
    searchFun() { this.search.page = 1; this.init(); },
    searchReset() {
      this.search = { keyword: '', organ_id: '', time: [], page: 1, limit: 6, total: 0 };
      this.init();
    },
    async init() {
      const s = this.search;
      const res = await adminGetProjectList({
        keyword: s.keyword, organ_id: s.organ_id,
        begin_time: s.time && s.time.length > 0 ? s.time[0] : '',
        end_time: s.time && s.time.length > 0 ? s.time[1] : '',
        pageIndex: s.page, pageSize: s.limit,
      });
      if (res && res.code === 200) { this.projectList = res.data.data || []; this.search.total = res.data.total || 0; }
    },
    goDetail(item) { this.$router.push({ path: '/adminhome/performance/detail', query: { projectId: item.id } }); },
    // 导入导出
    downloadTemplate() { window.open(this.importUrl.replace('importRule', 'downloadRuleTemplate'), '_blank'); },
    // 导出选中项目的合同（ZIP，异步+进度）
    exportContract() { this.startSelectedExport(() => adminExportContractZip(this.selectedProjectIds), '合同导出.zip'); },
    // 导出选中项目的绩效资料（ZIP，异步+进度）
    exportPerformance() { this.startSelectedExport(() => adminExportPerformanceZip(this.selectedProjectIds), '绩效资料导出.zip'); },
    // 督导材料综合打包导出（合同+绩效+月报汇总，ZIP，勾选项目）
    exportSupervision() { this.startSelectedExport(() => adminExportSupervisionZip(this.selectedProjectIds, '2026年7月'), '督导材料导出.zip'); },
    // 一键导出全部项目的所有资料（合同+绩效+月报，不勾选直接导出全部）
    exportAll() { this.$refs.exportProgress.start(() => adminExportSupervisionZip([], ''), '全部项目资料导出.zip'); },
    // 选中项目导出前的勾选校验
    startSelectedExport(apiCall, fileName) {
      if (this.selectedProjectIds.length === 0) { this.$message.warning('请先勾选要导出的项目'); return; }
      this.$refs.exportProgress.start(apiCall, fileName);
    },
    beforeImportUpload(file) {
      const isExcel = file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
      if (!isExcel) { this.$message.error('仅支持 .xls 或 .xlsx 格式'); return false; }
      return true;
    },
    handleImportSuccess(response) {
      if (response && response.code === 200) { this.$message.success(response.message || '导入成功'); this.init(); }
      else { this.$message.error((response && response.message) || '导入失败'); }
    },
    handleImportError() { this.$message.error('导入失败，请检查文件格式'); },
    // 分类管理
    async openClassDialog() {
      const res = await adminGetRuleClassList(0);
      if (res && res.code === 200) this.classList = res.data || [];
      this.classDialogShow = true;
    },
    addClassItem() { this.classFormTitle = '添加分类'; this.classForm = { id: 0, name: '' }; this.classFormShow = true; },
    editClassItem(row) { this.classFormTitle = '编辑分类'; this.classForm = { id: row.id, name: row.name }; this.classFormShow = true; },
    async handleSaveClass() {
      if (!this.classForm.name) { this.$message.warning('请输入分类名称'); return; }
      const res = await adminSaveRuleClass({ id: this.classForm.id, name: this.classForm.name });
      if (res && res.code === 200) {
        this.$message.success('保存成功'); this.classFormShow = false;
        const r = await adminGetRuleClassList(0); if (r && r.code === 200) this.classList = r.data || [];
      } else { this.$message.error((res && res.message) || '保存失败'); }
    },
    async deleteClassItem(row) {
      this.$confirm('确认删除分类「' + row.name + '」？', '提示', { type: 'warning' }).then(async () => {
        const res = await adminDeleteRuleClass(row.id);
        if (res && res.code === 200) { this.$message.success('删除成功'); this.openClassDialog(); }
        else { this.$message.error((res && res.message) || '删除失败'); }
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
@import url("index.scss");
</style>
